import Stamp from '../../../types/api/stamp'

// Межэтикетка штампа: берём сохранённый range, иначе пересчитываем по макс. укладке
export default function getDistance(stamp: Stamp) {
    if (stamp.range != null) {
        return stamp.range
    }

    const length = stamp.length || 0
    const roller = stamp.roller?.roller || 0
    const numberOfLabels = Math.floor(roller / length)

    if (!numberOfLabels) {
        return 0
    }

    return (roller - numberOfLabels * length) / numberOfLabels
}
